import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useLang } from "@/i18n";
import { API } from "@/config";

export function PaymentSuccess() {
  const { t } = useLang();
  const [state, setState] = useState("checking");

  useEffect(() => {
    window.scrollTo(0, 0);
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setState("fail"); return; }
    let tries = 0;
    let timer;
    const poll = async () => {
      tries++;
      try {
        const r = await fetch(`${API}/payments/status/${sid}`);
        const d = await r.json();
        if (d.payment_status === "paid") { setState("ok"); return; }
      } catch { /* retry */ }
      if (tries < 8) timer = setTimeout(poll, 2000);
      else setState("fail");
    };
    poll();
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="container-x py-20 max-w-md text-center" data-testid="payment-success-page">
      {state === "checking" && (
        <div data-testid="payment-checking">
          <Loader2 size={44} className="mx-auto animate-spin text-[#E11D48] mb-5" />
          <p className="text-zinc-300">{t("pay.checking")}</p>
        </div>
      )}
      {state === "ok" && (
        <div className="card-dark border-green-700/50 p-8" data-testid="payment-ok">
          <CheckCircle2 size={44} className="mx-auto text-[#22C55E] mb-4" />
          <h1 className="font-heading font-bold text-2xl text-white">{t("pay.ok")}</h1>
          <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{t("pay.okText")}</p>
        </div>
      )}
      {state === "fail" && (
        <div className="card-dark border-[#D97706]/40 p-8" data-testid="payment-pending">
          <XCircle size={44} className="mx-auto text-[#D97706] mb-4" />
          <h1 className="font-heading font-bold text-2xl text-white">{t("pay.fail")}</h1>
          <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{t("pay.failText")}</p>
        </div>
      )}
      <Link to="/" className="btn-outline mt-6" data-testid="payment-home-link">{t("pay.home")}</Link>
    </div>
  );
}

export function PaymentCancel() {
  const { t } = useLang();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="container-x py-20 max-w-md text-center" data-testid="payment-cancel-page">
      <div className="card-dark p-8">
        <XCircle size={44} className="mx-auto text-zinc-500 mb-4" />
        <h1 className="font-heading font-bold text-2xl text-white">{t("pay.cancelTitle")}</h1>
        <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{t("pay.cancelText")}</p>
      </div>
      <Link to="/" className="btn-outline mt-6" data-testid="payment-cancel-home-link">{t("pay.home")}</Link>
    </div>
  );
}
